import TableCellDescription from "ds/components/Table/Row/CellDescription";

import IntentProjectEnvironmentMountedFilesTableCell from "../Cell";
import { IntentProjectEnvironmentMountedFilesTableCellContentProps } from "../types";

const IntentProjectEnvironmentMountedFilesTableDescriptionCell = ({
  item: variable,
  ...cellProps
}: IntentProjectEnvironmentMountedFilesTableCellContentProps) => {
  return (
    <IntentProjectEnvironmentMountedFilesTableCell {...cellProps}>
      <TableCellDescription description={variable.description} />
    </IntentProjectEnvironmentMountedFilesTableCell>
  );
};

export default IntentProjectEnvironmentMountedFilesTableDescriptionCell;
